module.exports = __webpack_public_path__ + "img/banner.40c26110.jpg";